// extracted by mini-css-extract-plugin
export default {"fabWrapper":"fab_fabWrapper__lZ7WR","supportIcon":"fab_supportIcon__k7QvB","topButton":"fab_topButton__viVWS"};